import { computed } from 'vue';
import { useProductType } from '@composables/useProductType';
import { useProduct } from '@modules/product';
import safeType from '@utils/safeType';
import { useBrand } from './useBrand';

/**
 * @param {Product} [product]
 * @returns {product is WithMemberProducts}
 */
function hasMembers(product) {
  if (!product) {
    return false;
  }

  const {
    isConsolidatedMaster, isConsolidatedLatchKey, isMaster, isConsolidatedStandard,
  } = useProductType();

  return isConsolidatedMaster || isConsolidatedLatchKey || isMaster || isConsolidatedStandard;
}

/**
 *
 * @returns {{
 *  memberProductIds: import('vue').ComputedRef<string[]>,
 *  memberProductsMap: import('vue').ComputedRef<MasterProduct['relationships']['memberProductMap']>,
 *  memberProducts: import('vue').ComputedRef<BaseProduct.Product[]>,
 *  memberProductIdsString: import('vue').ComputedRef<number | string>,
 * }}
 */
export default function useMembersOfProduct() {
  const { productData: product } = useProduct();
  const { isMcom } = useBrand();

  if (hasMembers(product)) {
    const memberProductsMap = computed(() => safeType(product.relationships.memberProductMap, {}));
    const memberProductIds = computed(() => {
      if (product.relationships.memberProductIds && product.relationships.memberProductIds.length) {
        return safeType(product.relationships.memberProductIds, []);
      }
      if (isMcom && product.detail.memberDisplayGroupsMap?.['More Items'] && product.detail.memberDisplayGroupsMap?.['More Items'].length) {
        return safeType(product.detail.memberDisplayGroupsMap['More Items'], []);
      }
      return Object.keys(product.relationships.memberProductMap || {});
    });
    const memberProducts = computed(() => Object.values(memberProductsMap.value));
    const memberProductIdsString = computed(() => memberProductIds.value.join(',') || '');

    return {
      memberProductsMap,
      memberProducts,
      memberProductIds,
      memberProductIdsString,
    };
  }
  return {
    memberProductsMap: computed(() => ({})),
    memberProducts: computed(() => ([])),
    memberProductIds: computed(() => ([])),
    memberProductIdsString: computed(() => product.id),
  };
}
